import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Scroll to top on route change (but not for hash anchors)
    if (!hash) {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  // Always scroll to top on initial page load
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};

export default ScrollToTop;

